import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/apiClient";

export default function BrandsPage() {
  const [brands, setBrands] = useState([]);
  useEffect(() => { api.get("/brands").then((r) => setBrands(r.data)); }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16" data-testid="brands-page">
      <div className="mb-12">
        <div className="overline text-[color:var(--vt-orange)] mb-3">/ CATALOGUE</div>
        <h1 className="font-display font-black text-6xl md:text-7xl tracking-tighter">Trusted Brands</h1>
        <p className="text-neutral-600 mt-3 max-w-xl">Official partners. Original parts. Full manufacturer warranty.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-2">
        {brands.map((b) => (
          <Link key={b.name} to={`/shop?search=${encodeURIComponent(b.name)}`} className="border border-neutral-200 aspect-square flex items-center justify-center hover:border-black hover:bg-black hover:text-white transition-colors group" data-testid={`brand-${b.name}`}>
            <span className="font-display font-black text-xl tracking-tighter">{b.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
